"use client";

import React from "react";
import { ShieldCheck, BadgeCheck, Zap } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
const guarantees = [{
  title: "100% Exclusive Leads",
  description: "We never share or resell your prospects. Every lead generated through our branded campaigns is delivered exclusively to your sales team.",
  icon: ShieldCheck
}, {
  title: "Verified Contact Data",
  description: "Advanced validation protocols ensure you receive accurate phone numbers and emails, eliminating wasted time on dead ends and disconnected lines.",
  icon: BadgeCheck
}, {
  title: "Real-Time Delivery",
  description: "Strike while the iron is hot. High-intent prospects are routed directly to your CRM or inbox the exact second they submit their information.",
  icon: Zap
}];
export default function LeadQualityGuarantee() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const gridReveal = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="lead-quality-guarantee" className="dark bg-background text-foreground relative overflow-hidden border-t border-border/10 py-24 lg:py-32">
      {}
      <div className="absolute left-1/2 top-0 -translate-x-1/2 h-[500px] w-full max-w-4xl rounded-full bg-primary/5 blur-[120px] pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div ref={headerReveal.ref} className={`mx-auto max-w-2xl text-center mb-16 lg:mb-24 transition-all duration-1000 ${headerReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4">
            The Axebox Quality Guarantee
          </h2>
          <p className="text-muted-foreground text-lg">
            We engineer trust into every campaign. Our commitment to quality ensures your team spends less time filtering and more time closing.
          </p>
        </div>

        <div ref={gridReveal.ref} className={`grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 transition-all duration-1000 delay-200 ${gridReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {guarantees.map((item, i) => {
          const Icon = item.icon;
          return <div data-index={i} key={i} className="h-full">
                <Card className="h-full bg-card/30 backdrop-blur-sm border-border/40 hover:border-primary/40 transition-colors duration-500 rounded-2xl shadow-none">
                  <CardHeader className="pb-4">
                    <div className="size-12 rounded-xl bg-primary/10 flex items-center justify-center mb-4 border border-primary/20">
                      <Icon className="size-6 text-primary" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="text-xl">{item.title}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-base leading-relaxed text-muted-foreground">
                      {item.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}